// For default values stored in page meta
export const APP_VIEWS = {
  "View.Space.Around": {
    defaultValue: "default"
  },
  "View.Space.Around.Top": {
    defaultValue: "2px"
  },
  "View.Space.Around.Right": {
    defaultValue: "2px"
  },
  "View.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "View.Space.Around.Left": {
    defaultValue: "2px"
  },

  "View.Height.Type": {
    defaultValue: "fixed"
  },

  "View.Border.Style": {
    defaultValue: "solid"
  },
  "View.Border.Color": {
    ref: "Color.Black"
  },
  "View.Width": {
    defaultValue: "100%"
  },
  "View.Height": {
    defaultValue: "500px"
  },
  "View.Margin.Top": {
    defaultValue: "0px"
  },
  "View.Margin.Right": {
    defaultValue: "0px"
  },
  "View.Margin.Bottom": {
    defaultValue: "0px"
  },
  "View.Margin.Left": {
    defaultValue: "0px"
  },
  "View.Min.Height": {
    defaultValue: "0px"
  },
  "View.Max.Height": {
    defaultValue: "unset"
  },
  "View.Max.Width": {
    defaultValue: "unset"
  },
  "View.Min.Width": {
    defaultValue: "750px"
  },
  "View.Padding.Top": {
    defaultValue: "0px"
  },
  "View.Padding.Right": {
    defaultValue: "0px"
  },
  "View.Padding.Bottom": {
    defaultValue: "0px"
  },
  "View.Padding.Left": {
    defaultValue: "0px"
  },
  "View.Border.Top.Width": {
    defaultValue: "0px"
  },
  "View.Border.Right.Width": {
    defaultValue: "0px"
  },
  "View.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "View.Border.Left.Width": {
    defaultValue: "0px"
  },
  "View.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "View.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "View.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "View.Border.Top.Left.Radius": {
    defaultValue: "0px"
  }
};
